module.exports = __webpack_public_path__ + "img/index-banner-2.ff0e6559.jpg";